// TODO pujezdsky URL na resourcy pres devel proxy
export function getServerBasename() {
  if (process.env.NODE_ENV === 'production') {
    return '';
  }

  return 'http://bo.sokol.local:8081';
}
